export enum LessonType {
  LESSON = 'Lesson',
  UNIT_ASSESSMENT = 'Unit Assessment',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/lesson-type.ts